<template>
	<NuxtLink
		:to="switchLocalePath(alternativeLanguage.abbrev)"
		@click="setLanguage(alternativeLanguage.abbrev)"
	>
		{{ alternativeLanguage.name }}
	</NuxtLink>
</template>

<script setup lang="ts">
import { useLanguageLocalStorage } from '@/composables/useLocalStorage'
import type { Locale } from 'vue-i18n'
import { useI18n } from 'vue-i18n'

const switchLocalePath = useSwitchLocalePath()

const { setLanguage } = useLanguageLocalStorage()

const { locale } = useI18n()
const alternativeLanguage = computed(() => {
	return locale.value === 'en'
		? {
			abbrev: 'es' as Locale,
			name: 'Español'
		}
		: {
			abbrev: 'en' as Locale,
			name: 'English'
		}
})
</script>
